// src/hooks/auth/useAuthUser.ts
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';

import {
  setRoles,
  setIsLoading,
  setError,
  clearRoles,
} from '../../store/slices/auth/authUserSlice';

import AuthUserService from '../../services/auth/AuthUserService';
import useApiErrorHandler from '../useApiErrorHandler';

export const useAuthUser = () => {
  const dispatch: AppDispatch = useDispatch();
  const { handle } = useApiErrorHandler();

  const { roles, isLoading, hasLoaded, error } = useSelector(
    (state: RootState) => state.authUsers
  );

  // -----------------------------------------------------
  // Obtener roles del usuario autenticado
  // -----------------------------------------------------
  const fetchRoles = async () => {
    try {
      dispatch(setIsLoading(true));

      const response = await AuthUserService.getRoles();
      const { statusCode, data } = response;

      if (statusCode === 200) {
        dispatch(setRoles(data));
      }
    } catch (err: any) {
      handle(err);
      dispatch(setError(err?.message || 'Error al cargar roles del usuario.'));
    } finally {
      dispatch(setIsLoading(false));
    }
  };

  const hasRole = (role: string) => roles?.includes(role);

  return {
    roles,
    hasRole,
    isLoading,
    hasLoaded,
    error,

    fetchRoles,
    clearRoles: () => dispatch(clearRoles()),
  };
};
